import React from 'react';
import AppLayout from '../../../component/appLayout';
import { Table } from './styles';
import { Content, ContentHeading, Header, RightContent, Total, Text } from '../styles';

const Uninvoiced: React.FC = () => {
  return (
    <>
      <AppLayout>
        <Header>Uninvoiced</Header>
        <Content>
          <ContentHeading>
            <RightContent>
              <Total>
                <Text>Total (2023) : </Text>
                <Text> 12,283 USD</Text>
              </Total>
              <Text>
                <span>Export to CSV</span>
              </Text>
            </RightContent>
          </ContentHeading>
          <Table>
            <tr>
              <th>Projects</th>
              <th>Client Company</th>
              <th>hours (hh:mm)</th>
              <th>Expenses</th>
              <th>uninvoiced amount</th>
              <th></th>
            </tr>
            <tr>
              <td>Web Design, Logo Design </td>
              <td>Walter Melon</td>
              <td>__</td>
              <td>100</td>
              <td>100</td>
              <td>Create Invoice</td>
            </tr>
            <tr>
              <td>Logo Design, Editorial Calendar</td>
              <td>Buck Kinnear</td>
              <td>34:00</td>
              <td>150</td>
              <td>2,870</td>
              <td>Create Invoice</td>
            </tr>
            <tr>
              <td>Editorial Calendar, Logo Design</td>
              <td>Brock Lee</td>
              <td>30:00</td>
              <td>200</td>
              <td>4,055</td>
              <td>Create Invoice</td>
            </tr>
            <tr>
              <td>Editorial Calendar</td>
              <td>Jimmy Changa</td>
              <td>50:00</td>
              <td>450</td>
              <td>500</td>
              <td>Create Invoice</td>
            </tr>
            <tr>
              <td>Web Design, Editorial Calendar</td>
              <td>Holly Graham</td>
              <td>45:30</td>
              <td>300</td>
              <td>1,200</td>
              <td>Create Invoice</td>
            </tr>
            <tr>
              <td>
                <span>Total</span>
              </td>
              <td>
                <span></span>
              </td>
              <td>
                <span>159:30</span>
              </td>
              <td>
                <span>1200</span>
              </td>
              <td>
                <span>8725</span>
              </td>
              <td>
                <span></span>
              </td>
            </tr>
          </Table>
        </Content>
      </AppLayout>
    </>
  );
};

export default Uninvoiced;
